export const tasksTreeViewRoutesName = {
    tasksTreeView: "tasks-tree-view",
};
